module.exports = __webpack_public_path__ + "static/media/sprb.ca925efd.svg";